<template>
  <div>
    <div
      v-if="isDisplayOnly"
    >
      {{ nameByModelValue || $t('leadList.allTitle') }}
    </div>
    <LeadViewSelect
      v-else
      :selected-lead-view="leadView"
      @select-lead-view="setLeadViewSettings"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import type { LeadView } from '@/api/openapi';
import leadViewApi from '@/api/user/resources/lead_view';
import LeadViewSelect from '@/components/organisms/user/general/leadViewSelect/LeadViewSelect.vue';
import { useWait } from '@/composable/vue-wait';

type TProps = {
  isDisplayOnly?: boolean;
};

withDefaults(defineProps<TProps>(), {
  isDisplayOnly: false,
});

const leadViewId = defineModel<number | null>('leadViewId', { required: true });

const { doActionWithWait } = useWait();

const leadViews = ref<LeadView[]>([]);

const leadView = computed(() => {
  return leadViews.value.find((leadView) => leadView.id === leadViewId.value);
});

const nameByModelValue = computed(() => {
  return leadView.value?.name;
});

const getLeadViewsAction = async () => {
  await doActionWithWait('getLeadViewsWait', async () => {
    const res = await leadViewApi.getLeadViews({});
    leadViews.value = Object.values(res.data)[0] as LeadView[];
  });
};

const setLeadViewSettings = (leadView?: LeadView) => {
  leadViewId.value = leadView?.id ?? null;
};

onMounted(() => {
  getLeadViewsAction();
});
</script>
